import { createContext, PropsWithChildren, useContext } from 'react';
import { useTemplateLanguageController } from './controller';
import {
  TemplateLanguageProviderViewProps,
  TemplateLanguageContextParams,
} from './types';

export const TemplateLanguageContext =
  createContext<TemplateLanguageContextParams>({
    getTranslate(key) {
      return key;
    },
    getTranslateByLang: function (key: string, _lang: string): string {
      return key;
    },
  });

export function useTemplateLanguageContext() {
  return useContext(TemplateLanguageContext);
}

export function TemplateLanguageProvider({
  children,
  config,
}: PropsWithChildren<TemplateLanguageProviderViewProps>) {
  const value = useTemplateLanguageController(config);
  return (
    <TemplateLanguageContext.Provider value={value}>
      {children}
    </TemplateLanguageContext.Provider>
  );
}
